import { DropDownList, DropDownListChangeEvent } from '@progress/kendo-react-dropdowns';
import {
  GridColumnMenuFilter,
  GridColumnMenuFilterUIProps,
  GridColumnMenuProps,
} from '@progress/kendo-react-grid';
import { isUndefined } from 'lodash';
import { ComponentType, useState } from 'react';

export interface Option {
  text: string;
  operator: string | boolean;
}

const defaultOptions: Option[] = [
  {
    text: 'True',
    operator: 'true',
  },
  {
    text: 'False',
    operator: 'false',
  },
];

interface CustomGridColumnMenuProps extends GridColumnMenuProps {
  option?: Option[];
}
interface CustomGridColumnMenuFilterUIProps extends GridColumnMenuFilterUIProps {
  option?: Option[];
}

const BooleanFilterUI = (filterUIProps: CustomGridColumnMenuFilterUIProps) => {
  const filterChange = filterUIProps.firstFilterProps.onChange;
  const existingValue = filterUIProps.firstFilterProps.value;
  const value = isUndefined(existingValue) ? '' : existingValue;
  const filterOption = filterUIProps.option ?? defaultOptions;
  const [operator, setOperator] = useState<Option | undefined>(
    filterOption.find((option) => option.operator === value)
  );

  const handleChange = (e: DropDownListChangeEvent) => {
    setOperator(e.value);
    filterChange({
      value: e?.value?.operator,
      operator: 'eq',
      syntheticEvent: e.syntheticEvent,
    });
  };

  return (
    <>
      <DropDownList
        data={filterOption}
        value={operator}
        textField="text"
        dataItemKey="operator"
        onChange={handleChange}
      />
    </>
  );
};

const CustomDropdownFilter: ComponentType<CustomGridColumnMenuProps> = (columnMenuProps) => (
  <GridColumnMenuFilter
    {...columnMenuProps}
    expanded={true}
    hideSecondFilter
    filterUI={(filterUIProps) => (
      <BooleanFilterUI {...filterUIProps} option={columnMenuProps.option} />
    )}
  />
);

export default CustomDropdownFilter;
